import { Notification } from '../../../../../models/Notification'
import { StylesScene } from '../../../../../models/Story'
import { getNotificationImgPathes } from '../../resolveImgPath'

type TUserDoneDuedateTaskStyles = {
    [key: string]: StylesScene
}

const UserDoneDuedateTaskStyles: TUserDoneDuedateTaskStyles = {
    'Group': {
        
    },
    'Public': {
        mainImg: {
            container: {
                width: 305,
                height: 426,
                position: 'absolute',
                top: 360,
                left: 0,
                zIndex: 1,
            }
        },
        docTitle: {
            container: {
                top: 439,
                right: 12,
                position: 'absolute',
                padding: '5px 23px',
                borderRadius: 6,
                backgroundColor: '#0e0e14',
                width: 324,
                height: 125,
                overflow: 'auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 2,
            },
            text: {
                fontSize: 44,
                fornWeight: 500,
                color: '#fff',
                lineHeight: 1.32,
                textAlogn: 'center',
                textShadow: '0 2px 4px rgba(0, 0, 0, 0.35)',
            }
        },
    }
}
export const getUserDoneDuedateTaskBackground = (notif: Notification): [string, StylesScene] => {
    return [getNotificationImgPathes(notif.systemActionTypeUid)[notif.groupType], UserDoneDuedateTaskStyles[notif.groupType]]
}